export default "__VITE_ASSET__DQbX4Ejt__"